module.exports = __webpack_public_path__ + "static/media/CTLI_13-111w.feba332a.webp";